export default "__VITE_ASSET__a21dbc38__"